import Colors from '@/utils/colors';
import { globalTheme } from './globalTheme';
export const lightThemeOverrides = {
	...globalTheme,
	common: Colors.naiveBrand(),
	Layout: {
		color: Colors.canvas,
		headerColor: '#fff',
		headerBorderColor: Colors.cardBorder,
		siderColor: '#fff',
	},
	DataTable: {
		borderColor: Colors.cardBorder,
		thColor: '#fff',
		thTextColor: '#535C6A',
		thFontWeight: '600',
		tdColor: '#fff',
		tdColorHover: '#F2F4F6',
		tdColorStriped: '#fff',
		thPaddingMedium: '8px 12px',
		tdPaddingMedium: '4px 12px',
		fontSizeMedium: '13px',
		lineHeight: '1.3',
		boxShadowBefore: 'inset -8px 0 8px -8px rgba(26, 34, 32, 0.10)',
		boxShadowAfter: 'inset 8px 0 8px -8px rgba(26, 34, 32, 0.10)',
	},
	Table: {
		borderColor: Colors.cardBorder,
		thColor: '#F2F4F6',
		tdColor: '#fff',
		tdColorHover: '#F2F4F6',
	},
	Card: {
		color: '#fff',
		borderColor: Colors.cardBorder,
		borderRadius: '10px',
	},
	List: {
		// color: Colors.mainBackgroundColor,
		// borderColor: Colors.strokeColor,
	},
	Descriptions: {
		thFontWeight: 'bold',
		thColor: '',
		tdColor: '',
		borderColor: Colors.cardBorder,
	},

	Input: {
		color: '#fff',
		border: `1px solid ${Colors.cardBorder}`,
		borderHover: `1px solid ${Colors.primaryColor}`,
		borderFocus: `1px solid ${Colors.primaryColor}`,
	},
	Button: {
		fontWeight: '500',
	},
};
